var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.userAgreementCn)?_c('userAgreementCn'):_vm._e(),_vm._v(" "),(_vm.userAgreementTw)?_c('userAgreementTw'):_vm._e(),_vm._v(" "),(_vm.userAgreementUs)?_c('userAgreementUs'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8a5339cc","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/userAgreement.vue
// module id = null
// module chunks = 